var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',{ref:"axis",attrs:{"transform":`translate(0, ${_vm.innerHeight + _vm.offset})`}})
}
var staticRenderFns = []

export { render, staticRenderFns }